// tslint:disable-next-line:eofline
// export const URL_SERVICES = 'http://localhost:3000';
// export const URL_SERVICES = 'https://alag-backend2.herokuapp.com';
export const URL_SERVICES = 'https://inscripcion.alag2019.org';

// export const URL_FRONTEND = 'http://localhost:4200';
// export const URL_FRONTEND = 'https://alag-inscripciones.firebaseapp.com';

export const URL_FRONTEND = 'https://inscripcion.alag2019.org/';


// WEBPACK FOOTER //
// ./src/app/config/config.ts